import classNames from 'classnames';
import React from 'react';
import { Tracker, ClickEvent } from '@udemy/event-tracking';
import { useI18n } from '@udemy/i18n';
import { Icon } from '@udemy/icons';
import { Button } from '@udemy/react-core-components';
import { udLink } from '@udemy/ud-data';
import { InDemandCareerCard } from './in-demand-career-card.react-component';
import styles from "./in-demand-career.module.css";
export const InDemandCareerWrapper = ({
  academies,
  buttonProps,
  className,
  headingProps,
  isUSMarketplace,
  uiRegion
}) => {
  const {
    gettext
  } = useI18n();
  const trackAllCareersClick = () => {
    Tracker.publishEvent(new ClickEvent({
      componentName: 'seeAllCareers'
    }));
  };
  if (!(academies !== null && academies !== void 0 && academies.length)) {
    return null;
  }
  const innerHeadingProps = {
    children: gettext('Explore more in-demand careers'),
    ...headingProps,
    className: classNames(styles['in-demand-heading'], 'ud-heading-xxl', headingProps === null || headingProps === void 0 ? void 0 : headingProps.className)
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(styles['in-demand-container'], 'ud-container', className)
  }, /*#__PURE__*/React.createElement("h2", innerHeadingProps), /*#__PURE__*/React.createElement("div", {
    className: styles.wrapper
  }, academies.map(academy => /*#__PURE__*/React.createElement(InDemandCareerCard, {
    key: academy.slug,
    academy: academy,
    isUSMarketplace: isUSMarketplace,
    uiRegion: uiRegion
  }))), /*#__PURE__*/React.createElement(Button, Object.assign({
    componentClass: "a",
    udStyle: "secondary",
    href: udLink.to('/career-accelerators/'),
    onClick: trackAllCareersClick,
    target: "_self",
    size: "medium"
  }, buttonProps, {
    className: classNames(styles['view-all-careers-link'], buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.className)
  }), gettext('All Career Accelerators'), (buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.udStyle) === 'ghost' && /*#__PURE__*/React.createElement(Icon, {
    label: false,
    glyph: "arrow-right",
    className: "ud-icon-bi-directional"
  })));
};
//# sourceMappingURL=in-demand-career-wrapper.react-component.js.map